/**
 * Resolve URLs com placeholder {host} substituído pelo hostname atual.
 *
 * Permite que `.env` use templates portáveis em vez de hostnames fixos:
 *
 *   VUE_APP_APIURL=https://{host}:8443
 *   VUE_APP_SOCKET_URL=http://{host}:3000
 *   VUE_APP_SOCKET_URL_HTTPS=https://{host}:8443
 *
 * Assim o mesmo build serve qualquer domínio — basta o backend estar
 * acessível no mesmo hostname onde o frontend foi servido.
 *
 * Placeholders suportados:
 *   {host}      → window.location.hostname (ex: pcdob.facilita.ae)
 *   {hostname}  → idem
 *   {protocol}  → "https" ou "http" (sem ":")
 *   {origin}    → window.location.origin (ex: https://pcdob.facilita.ae)
 *
 * URLs sem placeholder são retornadas inalteradas (backward-compatible).
 */
export default function resolveUrl(value) {
  if (!value) return value;
  if (typeof window === 'undefined') return value;

  const host = window.location.hostname;
  const protocolo = (window.location.protocol || 'https:').replace(/:$/, '');
  const origin = window.location.origin || `${protocolo}://${host}`;

  return String(value)
    .replace(/\{host(name)?\}/g, host)
    .replace(/\{protocol\}/g, protocolo)
    .replace(/\{origin\}/g, origin);
}
